import { isEmpty } from 'lodash';

export const getBase64ImageFromUrl = async (url: string): Promise<string> => {
	const res = await fetch(url);
	const blob = await res.blob();

	return new Promise((r) => {
		const reader = new FileReader();
		reader.addEventListener('load', () => r(reader.result as string));
		reader.readAsDataURL(blob);
	});
};

export const getBase64ImageData = async (url: string) => {
	const base64String = await getBase64ImageFromUrl(url);
	const base64Data = base64String.split(',')[1];
	return base64Data;
};

export const resolveImageData = async (imageObj?: {
	data: string;
	[key: string]: string;
}) => {
	if (!imageObj || isEmpty(imageObj)) return undefined;

	const { data } = imageObj;
	if (!data) return imageObj;

	return {
		...imageObj,
		data: await getBase64ImageData(data),
	};
};
